import { Emulator, MEMORY_SIZE } from "./emulator.js";

export type AssembledImage = {
  base: number;
  bytes: Uint8Array;
};

const WORKBENCH_MAX_OUTPUT_BYTES = 4096;

function ensureAddressSpaceRange(start: number, nextPc: number): void {
  if (start < 0 || start >= MEMORY_SIZE) {
    throw new Error("workbench addresses must stay within 0x0000..0xFFFF");
  }
  if (nextPc < 0 || nextPc > MEMORY_SIZE) {
    throw new Error("workbench addresses must stay within 0x0000..0xFFFF");
  }
}

export function assembleSource(emulator: Emulator, source: string): AssembledImage {
  const assembled = emulator.assembleWorkbenchSource(source);
  if (assembled.bytes.length === 0) {
    throw new Error("no assembled bytes were produced");
  }
  if (assembled.bytes.length > WORKBENCH_MAX_OUTPUT_BYTES) {
    throw new Error(`assembled output exceeds the browser workbench limit of ${WORKBENCH_MAX_OUTPUT_BYTES} bytes`);
  }
  ensureAddressSpaceRange(assembled.base, assembled.base + assembled.bytes.length);
  return assembled;
}
